module.exports = __webpack_public_path__ + "img/manage_icon.ddb224a8.png";